import { useAppAuth } from '../auth/appAuth';

/**
 * Development auth bypass hook
 * 
 * When REACT_APP_BYPASS_AUTH=true, returns a mock admin user
 * Otherwise, returns the real Auth0 user
 * 
 * Usage: Replace `useAppAuth()` with `useDevAuth()` in admin pages
 */

const DEV_BYPASS_AUTH = process.env.REACT_APP_BYPASS_AUTH === 'true';

// Mock user that simulates an admin (Google OAuth with @crant.ai email)
const DEV_MOCK_USER = {
  sub: 'google-oauth2|dev-bypass-12345',
  email: 'dev@crant.ai',
  name: 'Dev User (Bypass)',
  picture: undefined,
  email_verified: true,
};

export const useDevAuth = () => {
  const auth0 = useAppAuth();

  if (DEV_BYPASS_AUTH) {
    return {
      ...auth0,
      isAuthenticated: true,
      isLoading: false,
      user: DEV_MOCK_USER,
    };
  }

  return auth0;
};

export default useDevAuth;

